// extracted by mini-css-extract-plugin
export default {"center":"Spinner_center__T2VEQ","spinner":"Spinner_spinner__DJ8gv","spinner-aib1d7":"Spinner_spinner-aib1d7__VONs+"};